import { UiSchema } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';

const uiGrid: UIGridElement[] = [
  { fields: { attachedToId: 6, type: 6 } },
  { fields: { instructions: 12 } },
  { title: 'Supplied codes', fields: { codes: 12 } }
];

export const accessControlFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  instructions: {
    'ui:widget': 'textarea'
  },
  codes: {
    'ui:field': 'codesEditor'
  }
};
